// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tracked-ui{position:absolute;z-index:1000;transform:translate(-50%,-50%);opacity:0;pointer-events:none;transition:opacity .5s ease-in-out}.tracked-ui.visible{opacity:1;pointer-events:all}.tracked-ui.destroyed{opacity:0!important;pointer-events:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
